module.exports = "https://drv7djjgp3j3.cloudfront.net/f14feaec-818c-4d31-af5e-fd46c35896d3/images/favicon_123tv.png?4b7e499d893fadc9693231cfdf3c6e55";